// extracted by mini-css-extract-plugin
export var modalFooter = "_pf-0";